import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "list"]

  filter() {
    const query = this.inputTarget.value.toLowerCase().trim()
    if (!this.hasListTarget) return

    const rows = this.listTarget.querySelectorAll("a[data-username]")
    rows.forEach(row => {
      const username = row.dataset.username || ""
      const name = row.dataset.name || ""
      const match = !query || username.includes(query) || name.includes(query)
      row.style.display = match ? "" : "none"
    })
  }
}
